import React from 'react';

import TimeInput, { TimeInputProps } from './TimeInput';
import { padNumber } from '../helpers';

const NumberInput = React.forwardRef<HTMLInputElement, TimeInputProps>(
  ({ className, style, value, ...props }, ref) => {
    value = padNumber(value);

    return <TimeInput ref={ref} placeholder={'00'} value={value} {...props} />;
  },
);

NumberInput.displayName = 'NumberInput';

NumberInput.propTypes = TimeInput.propTypes;

export default NumberInput;
